import React from 'react';
import { useBFFStyleOptions } from '../hooks/state/useBFFStyleOptions';
const ActivityStatus = ({ sender, formattedTimestamp, grouped }) => {
    const styleOptions = useBFFStyleOptions();
    const style = grouped
        ? {
            color: 'transparent',
            height: '1px',
            overflow: 'hidden',
            position: 'absolute',
            top: '0',
            whiteSpace: 'nowrap',
            width: '1px'
        }
        : {
            fontFamily: styleOptions.primaryFont,
            color: '#666666',
            fontSize: '80%',
            padding: '5px 0 0 0'
        };
    const groupClass = grouped ? ' bffTimestampGrouped' : '';
    return (React.createElement("span", { className: `activityStatus activityStatus__timestamp${groupClass}` },
        React.createElement("span", { className: "activityStatus__timestampPretext", style: style }, `${sender} at ${formattedTimestamp}`)));
};
export const ActivityStatusMiddleware = (styleOptions, config = {}) => () => (next) => (args) => {
    const { showSeconds = false } = config;
    const { activity: { from: { role, name }, timestamp, localTimestamp }, sendState, sameTimestampGroup } = args;
    const formattedTimestamp = new Date(timestamp || localTimestamp).toLocaleTimeString(undefined, {
        hour: 'numeric',
        minute: '2-digit',
        second: showSeconds ? '2-digit' : undefined,
        hourCycle: 'h12'
    });
    const sender = role === 'user' ? 'you' : name;
    if (['sending', 'send failed'].includes(sendState)) {
        return next(args);
    }
    else {
        return (React.createElement(ActivityStatus, { sender: sender, formattedTimestamp: formattedTimestamp, grouped: styleOptions.groupTimestamp && sameTimestampGroup }));
    }
};
//# sourceMappingURL=activityStatusMiddleware.js.map